/**
 * Web-only native `<input type="time">` styled with Vuelto control tokens.
 * Pair with HmTimeField / LocalTimeField on native.
 *
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React, { createElement } from 'react';
import { View, type StyleProp, type ViewStyle } from 'react-native';
import {
  webNativeTemporalInputStyle,
  type WebNativeTemporalSize,
} from './webNativeTemporalInput';

type Props = {
  value: string;
  onChange: (hm: string) => void;
  ariaLabel?: string;
  disabled?: boolean;
  size?: WebNativeTemporalSize;
  /** Narrow column in hour grids (store hours). */
  compactWidth?: boolean;
  style?: StyleProp<ViewStyle>;
};

const HM_RE = /^\d{2}:\d{2}$/;

export const WebTimeInput = ({
  value,
  onChange,
  ariaLabel = 'Hora',
  disabled = false,
  size = 'default',
  compactWidth = false,
  style,
}: Props) => {
  const inputStyle = webNativeTemporalInputStyle(
    compactWidth
      ? { size: size === 'comfortable' ? 'comfortable' : 'compact', width: 112, minWidth: 112, textAlign: 'center', fontWeight: '600' }
      : { size, fontWeight: '600' }
  );

  return (
    <View style={[{ minWidth: 0 }, compactWidth ? { width: 112 } : { flex: 1, width: '100%' }, style]}>
      {createElement('input', {
        type: 'time',
        value: HM_RE.test(value.trim()) ? value.trim() : '',
        disabled,
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
          const next = e.target.value ?? '';
          if (HM_RE.test(next)) onChange(next);
        },
        style: inputStyle,
        'aria-label': ariaLabel,
      })}
    </View>
  );
};
